import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { useTriviaStore } from '@wwe-portal/web/providers/stores/trivia-store';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { cn } from '../../../../../packages/ui/lib/lib';

export const TriviaGoHome: FC<{ className?: string }> = ({ className }) => {
  const closeGame = useTriviaStore((state) => state.closeGame);
  const t = useTranslations();
  return (
    <ClickableDiv
      onClick={closeGame}
      className={cn(
        'text-inlineTextColor12 underline underline-offset-2',
        className
      )}
      data-id={'trivia_victory_page_go_home'}
    >
      {t('home')}
    </ClickableDiv>
  );
};
